import React from 'react';
import { Link } from 'react-router-dom';
import { PRODUCERS } from '../../data/smaken';
import { Reveal } from '../Reveal';
import { ArrowMark } from '../Marks';
export function Producers() {
  return <section aria-labelledby="producenter-rubrik" className="border-t border-black/12" data-id="element-579" data-mp="vtc8l5m3w3io">
      <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-24" data-id="element-580" data-mp="10r4bsvs7bc26">
        <Reveal data-id="element-581" data-mp="10tgpuxuu929y">
          <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr),minmax(0,1fr)] lg:items-end" data-id="element-582" data-mp="m2zrjndi2sha">
            <h2 id="producenter-rubrik" className="display-xl text-5xl uppercase sm:text-7xl" data-id="element-583" data-mp="qt6frm43oaz0">
              Från Småland.
            </h2>
            <p className="max-w-md text-lg leading-relaxed text-black/70 lg:justify-self-end" data-id="element-584" data-mp="d3cnsuxatal2">
              Människorna, råvarorna och hantverket bakom det goda. Här kommer maten ifrån.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid gap-12 md:grid-cols-3" data-id="element-585" data-mp="3680grrpv92o">
          {PRODUCERS.map((producer, i) => <Reveal key={producer.slug} delay={Math.min(i * 0.07, 0.2)} data-id="element-586" data-mp="84t5d4hwygxg" data-mpi={i}>
              <Link to={`/plats/${producer.slug}`} className="group block" data-id="element-587" data-mp="1eq6ppvwuu6rd">
                <div className="aspect-[3/4] overflow-hidden bg-black/5" data-id="element-588" data-mp="19s55v8rlu3eu">
                  <img src={producer.image} alt={`${producer.person}, ${producer.craft} på ${producer.name}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-[280ms] ease-out group-hover:scale-[1.03]" data-id="element-589" data-mp="1nt7tvr25tnse" />
                </div>
                <blockquote className="mt-6 border-l-2 border-rod pl-5" data-id="element-590" data-mp="r0cetjw3is9r">
                  <p className="font-display text-xl italic leading-snug text-black/85" data-id="element-591" data-mp="14vercpvg7fvj">
                    ”{producer.quote}”
                  </p>
                </blockquote>
                <p className="mt-5 font-display text-2xl uppercase transition-colors duration-150 ease-out group-hover:text-rod" data-id="element-592" data-mp="ccrefxqlv75j">
                  {producer.person}
                </p>
                <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide2 text-black/50" data-id="element-593" data-mp="27h7hur8bsdno">
                  {producer.craft} · {producer.name} · {producer.city}
                </p>
              </Link>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-594" data-mp="2h8lkv8zhjvlk">
          <Link to="/upptack?kategori=handla" className="group mt-14 inline-flex items-center gap-3 border-b-2 border-black pb-1.5 text-[12px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out hover:border-rod hover:text-rod" data-id="element-595" data-mp="2m5c1pyj46v81">
            Möt producenterna
            <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-596" data-mp="1yfrfn6rnzhuj" />
          </Link>
        </Reveal>
      </div>
    </section>;
}